import { Breadcrumb, Button, Col, Form, Input, Row, Spin } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Get_Widget_Cdn, Update_Widget_Cdn } from "../../redux/SuperAdmin/SuperAdminActions";

const WidgetCdnSettings = () => {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const userData = useSelector((state) => state.Auth.userData);
  const widgetCdnUrl = useSelector((state) => state.SuperAdminReducer.widgetCdnUrl);
  const widgetCdnLoading = useSelector((state) => state.SuperAdminReducer.widgetCdnLoading);
  const widgetCdnSaving = useSelector((state) => state.SuperAdminReducer.widgetCdnSaving);

  useEffect(() => {
    dispatch(Get_Widget_Cdn());
  }, [dispatch]);

  useEffect(() => {
    if (widgetCdnUrl) {
      form.setFieldsValue({ widgetCdnUrl });
    }
  }, [widgetCdnUrl, form]);

  const submitHandler = (values) => {
    dispatch(
      Update_Widget_Cdn({
        _id: userData?._id,
        widgetCdnUrl: values.widgetCdnUrl?.trim(),
      })
    );
  };

  return (
    <>
      <Breadcrumb className="breadCrumb" items={[{ title: "Settings" }, { title: "Widget CDN" }]} />
      <Row className="addShortcut">
        <Col span={24}>
          {widgetCdnLoading && !widgetCdnUrl ? (
            <Spin />
          ) : (
            <Form
              form={form}
              name="widget-cdn-settings"
              labelCol={{ span: 4 }}
              layout="horizontal"
              className="ticketForm"
              onFinish={submitHandler}
            >
              <Form.Item
                name="widgetCdnUrl"
                wrapperCol={{ span: 14 }}
                label="Widget CDN URL"
                extra="This URL is used in the website embed script shown to companies."
                rules={[
                  {
                    required: true,
                    message: "Please enter the widget CDN URL",
                  },
                  {
                    type: "url",
                    message: "Please enter a valid URL",
                  },
                ]}
              >
                <Input placeholder="https://cdn.convobird.com/media/chat-widget.umd.cjs" />
              </Form.Item>
              <div className="topbtn">
                <Button type="primary" className="align-right" htmlType="submit" loading={widgetCdnSaving}>
                  Save
                </Button>
              </div>
            </Form>
          )}
        </Col>
      </Row>
    </>
  );
};

export default WidgetCdnSettings;
